var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2822 9.37111C18.6274 9.37111 19.7178 8.28067 19.7178 6.93555C19.7178 5.59044 18.6274 4.5 17.2822 4.5C15.9371 4.5 14.8467 5.59044 14.8467 6.93555C14.8467 8.28067 15.9371 9.37111 17.2822 9.37111Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2822 20.5C18.6274 20.5 19.7178 19.4096 19.7178 18.0645C19.7178 16.7193 18.6274 15.6289 17.2822 15.6289C15.9371 15.6289 14.8467 16.7193 14.8467 18.0645C14.8467 19.4096 15.9371 20.5 17.2822 20.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93555 14.9356C8.28067 14.9356 9.37111 13.8451 9.37111 12.5C9.37111 11.1549 8.28067 10.0645 6.93555 10.0645C5.59044 10.0645 4.5 11.1549 4.5 12.5C4.5 13.8451 5.59044 14.9356 6.93555 14.9356Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75781 13.291L15.0245 16.8732",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0245 8.12671L8.75781 11.7089",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b1f8654ea3f27d06eb5f89af327cf3ce.svg";
export { ForwardRef as ReactComponent };